<template>
  <circle cx="50" cy="50" r="1" />
</template>

<script>
export default {
  name: 'Pattern' + 'Dot'
};
</script>
